/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCasePerson } from './InternalApiCasePerson';
import {
    InternalApiCasePersonFromJSON,
    InternalApiCasePersonFromJSONTyped,
    InternalApiCasePersonToJSON,
    InternalApiCasePersonToJSONTyped,
} from './InternalApiCasePerson';

/**
 * 
 * @export
 * @interface InternalApiCasePersonPage
 */
export interface InternalApiCasePersonPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCasePersonPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCasePersonPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCasePersonPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiCasePerson>}
     * @memberof InternalApiCasePersonPage
     */
    content: Array<InternalApiCasePerson>;
}

/**
 * Check if a given object implements the InternalApiCasePersonPage interface.
 */
export function instanceOfInternalApiCasePersonPage(value: object): value is InternalApiCasePersonPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiCasePersonPageFromJSON(json: any): InternalApiCasePersonPage {
    return InternalApiCasePersonPageFromJSONTyped(json, false);
}

export function InternalApiCasePersonPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCasePersonPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiCasePersonFromJSON)),
    };
}

export function InternalApiCasePersonPageToJSON(json: any): InternalApiCasePersonPage {
    return InternalApiCasePersonPageToJSONTyped(json, false);
}

export function InternalApiCasePersonPageToJSONTyped(value?: InternalApiCasePersonPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiCasePersonToJSON)),
    };
}

